import { fetchChatWelcomeMessage } from 'actions/supportAssistant/supportAssistantActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useChatWelcomeMessage(): [App.ChatMessage | undefined, boolean | undefined, any] {
  const appDispatch = useAppDispatch()

  const message = useAppSelector(state => state.supportAssistant.welcomeMessage)

  useEffect(() => {
    appDispatch(fetchChatWelcomeMessage())
  }, [appDispatch])

  return [
    message.message,
    message.fetching,
    message.error,
  ]
}

export default useChatWelcomeMessage
